import type { RouteRecordRaw } from 'vue-router'
const posRoutes: RouteRecordRaw = {
  path: '/pos', name: 'POS', redirect: '/pos/session',
  meta: { title: 'POS零售', icon: 'icon-desktop' },
  children: [
    { path: 'session', name: 'PosSession', component: () => import('@/views/pos/SessionList.vue'), meta: { title: '收银会话' } },
    { path: 'profile', name: 'PosProfile', component: () => import('@/views/pos/ProfileList.vue'), meta: { title: 'POS配置' } },
    { path: 'invoice', name: 'PosInvoice', component: () => import('@/views/pos/InvoiceList.vue'), meta: { title: '零售单据' } },
  ],
}
export default posRoutes
